<template>
  <v-container class="py-12">
    <v-row justify="center">
      <v-col
        xl="3"
        style="max-width: 350px;"
      >
        <div class="text-center mb-10">
          <img
            src="@/assets/img/logo.svg"
            width="160px"
            alt="Ultrax Logo"
          >
        </div>
        <v-card
          color="white"
          class="pa-8 pt-5 elevation-10"
          rounded="lg"
        >
          <form @submit.prevent="submit()">
            <div class="text-h5 text-center mb-6">
              Set Password For Ultrax Account
            </div>
            <validation-observer ref="validation">
              <validation-provider
                v-slot="{ errors }"
                rules="required|password_policy"
                vid="password"
              >
                <password-field
                  ref="password"
                  v-model="password"
                  :error-messages="errors"
                  :label="$t('text_input.login.password.title')"
                  outlined
                  type="password"
                  append-icon="fa-light fa-key"
                />
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                rules="required|confirmed:password"
              >
                <password-field
                  v-model="password_repeat"
                  :error-messages="errors"
                  :label="$t('text_input.user.repeat_password.title')"
                  outlined
                  type="password"
                  append-icon="fa-light fa-key"
                />
              </validation-provider>
            </validation-observer>

            <v-btn
              block
              large
              type="submit"
              color="primary"
              class="ma-0 text-none"
              :loading="submitting"
            >
              {{ $t('training_builder.button.save') }}
            </v-btn>
          </form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AuthApiService } from '@/data/services'
import PasswordField from '@/components/inputs/PasswordField.vue'

export default {
    name: 'ForgotPasswordView',
  components: { PasswordField },
    data() {
      return {
        password: '',
        password_repeat: '',
        submitting: false,
        email: '',
        token: ''
      }
    },
    created() {
      if (this.$route.query.data) {
        const data = JSON.parse(atob(this.$route.query.data))

        this.email = data.email
        this.token = data.token
      } else {
        this.email = this.$route.query.email
        this.token = this.$route.query.token
      }
    },
    methods: {
      async submit() {
        if (!(await this.$refs.validation.validate())) {
          return
        }

        await this.save()
      },
      async save() {
        try {
          this.submitting = true

          const result = await AuthApiService.resetPassword({
            email: this.email,
            password: this.password,
            password_confirmation: this.password_repeat,
            token: this.token
          })

          const success = result.status

          if (success) {
            if (this.$route.name === this.$routeNames.FINISH_SIGNUP) {
              this.$store.dispatch(this.$storeActions.ALERT, {
                text: this.$t('alert.account_set_up.success'),
                color: 'success'
              })
            } else {
              this.$store.dispatch(this.$storeActions.ALERT, {
                text: this.$t('alert.password_reset.success'),
                color: 'success'
              })
            }

            this.$router.push({ name: this.$routeNames.LOGIN })

            return
          }

          if (this.$route.name === this.$routeNames.FINISH_SIGNUP) {
            this.$store.dispatch(this.$storeActions.ALERT, {
              text: this.$t('alert.something_went_wrong_account_setup_link.error'),
              color: 'error'
            })
          } else {
            this.$store.dispatch(this.$storeActions.ALERT, {
              text: this.$t('alert.something_went_wrong_password_link.error'),
              color: 'error'
            })
          }
        } catch (e) {
          this.$store.dispatch(this.$storeActions.ALERT, {
            text: this.$t('alert.set_password_link.error'),
            color: 'error'
          })

          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
